/**
 * The 11 products, in range order (Roofs & patios, Screens & shade, Living spaces), then legacy order.
 *
 * Content provenance (BR-WEB-006 / baseline § 5): every word is the legacy greatwaypatios.com.au copy
 * with typo-only edits, as captured in docs/retrofit-capture/legacy-website/content.json and carried by
 * the approved prototype (docs/specs/greatway-patios/mockups/client-portal-prototype.html). Taglines and
 * ranges are the prototype's information architecture (BR-WEB-012). Never add claims here.
 *
 * Image paths are served from public/images/website/** (EXIF-stripped — BR-WEB-024).
 */
import type { RangeId } from "./site";

export interface ProductSection {
  heading: string;
  paras: string[];
}

export interface Product {
  /** URL slug — /products/{slug}. */
  slug: string;
  /** Slug on the legacy site (differs only for Ziptrak: ziptrack-blinds). */
  legacySlug: string;
  name: string;
  range: RangeId;
  /** Range display name, shown as the card eyebrow. */
  category: string;
  tagline: string;
  hero: string;
  intro: string[];
  highlights: string[];
  sections: ProductSection[];
  images: string[];
}

export const PRODUCTS: readonly Product[] = [
  {
    "slug": "patios",
    "legacySlug": "patios",
    "name": "Patios",
    "range": "roofs-and-patios",
    "category": "Roofs & patios",
    "tagline": "Skillion, gable, bay and gazebo-end designs",
    "hero": "/images/website/insulatedroof/gable-patiol-2lq.jpg",
    "intro": [
      "Greatway Patios have worked continually to improve the range of outdoor patio products available to our customers. From skillion, gables, bay and gazebo end patios, we will create the ultimate area for you. Long span roof sheeting and clean, high gloss beams and posts will transform your area. Let our experienced team help you design an area with that special Greatway Patios touch."
    ],
    "highlights": [],
    "sections": [
      {
        "heading": "Flat Roof",
        "paras": [
          "Keep your costs down with a skillion patio from Greatway Patios. Ideal for carports attached to the house, patio over a deck or either side of a gable designed patio. Consider truncating the corners of a rectangle patio to give a softer look to your outdoor area. Your options are endless at Greatway Patios. Call today for a free measure and quote."
        ]
      },
      {
        "heading": "Gable Roof",
        "paras": [
          "Greatway Patios can create a feel of openness and understated elegance in your patio with a gable roof design. Choose between Dutch Gable a Traditional Gable or the Hip design patio roof. Come and ask our qualified staff at Greatway Patios on the gable that best suits your home and lifestyle. We will take the time to ensure that you will have a patio you can enjoy entertaining under for years to come."
        ]
      }
    ],
    "images": [
      "/images/website/patios/image14.jpg",
      "/images/website/insulatedroof/insulated-skillion.jpg",
      "/images/website/insulatedroof/dewsbury-1.jpg",
      "/images/website/insulatedroof/dewsbury-20.jpg",
      "/images/website/insulatedroof/img-0264.jpg",
      "/images/website/insulatedroof/prestridge.jpg",
      "/images/website/insulatedroof/prestridge1.jpg",
      "/images/website/patios/image8.jpg",
      "/images/website/patios/image16.jpg",
      "/images/website/insulatedroof/img-0324.jpg",
      "/images/website/insulatedroof/osullivan10.jpg",
      "/images/website/insulatedroof/sorley.jpg",
      "/images/website/insulatedroof/gillam-patio-lq-3.jpg",
      "/images/website/insulatedroof/greatwaypatios15.jpg",
      "/images/website/insulatedroof/greatwaypatios-lq11.jpg",
      "/images/website/insulatedroof/bampton00.jpg",
      "/images/website/insulatedroof/wallis-1.jpg",
      "/images/website/insulatedroof/gable-patiol-2lq.jpg",
      "/images/website/insulatedroof/gable-patiol-3lq.jpg",
      "/images/website/insulatedroof/miegel6.jpg",
      "/images/website/insulatedroof/greatwaypatios16.jpg",
      "/images/website/insulatedroof/wallis-10.jpg",
      "/images/website/insulatedroof/bampton01.jpg"
    ]
  },
  {
    "slug": "insulated-roof",
    "legacySlug": "insulated-roof",
    "name": "Insulated Roof",
    "range": "roofs-and-patios",
    "category": "Roofs & patios",
    "tagline": "Clean long spans with a ceiling-like finish",
    "hero": "/images/website/insulatedroof/greatwaypatios14.jpg",
    "intro": [
      "In recent years, insulated roof panels have been developed to offer an alternative to the single skin patio roof systems. Greatway Patios can offer a number of insulated products to complement your outdoor area, room enclosure, gables, skillions and other roof styles.",
      "Insulated roofing will give you clean long spans for your patio. The beautiful ceiling like finish is ideal for room enclosures to alleviate any condensation. Insulated sheeting is also the answer for those extremely hot areas where the unique insulated sandwich panel provides year round protection. Insulated roof panels are available in many different colours, thicknesses and styles to match your needs. Greatway Patios specialise in design and construction for outdoor areas utilizing this insulated product. Talk to Greatway Patios today about the benefits you will enjoy with insulated roof sheeting."
    ],
    "highlights": [],
    "sections": [],
    "images": [
      "/images/website/insulatedroof/gwp-insulated.jpg",
      "/images/website/insulatedroof/greatwaypatios15.jpg",
      "/images/website/insulatedroof/wallis-1.jpg",
      "/images/website/insulatedroof/gable-patiol-2lq.jpg",
      "/images/website/insulatedroof/insulated-skillion.jpg",
      "/images/website/insulatedroof/gable-patiolq.jpg",
      "/images/website/insulatedroof/img-0324.jpg",
      "/images/website/insulatedroof/img-0328.jpg",
      "/images/website/insulatedroof/greatwaypatios14.jpg",
      "/images/website/insulatedroof/prestridge.jpg",
      "/images/website/insulatedroof/img-0264.jpg",
      "/images/website/insulatedroof/kemp5.jpg",
      "/images/website/latticeandslatting/miegel6.jpg",
      "/images/website/insulatedroof/osullivan10.jpg",
      "/images/website/insulatedroof/kemp8.jpg",
      "/images/website/insulatedroof/image13.jpg",
      "/images/website/insulatedroof/image14.jpg",
      "/images/website/insulatedroof/gables005.jpg",
      "/images/website/insulatedroof/kemp1.jpg",
      "/images/website/insulatedroof/gables006.jpg",
      "/images/website/insulatedroof/img-0081.jpg"
    ]
  },
  {
    "slug": "opening-roof-vergolas",
    "legacySlug": "opening-roof-vergolas",
    "name": "Opening Roof – Vergolas",
    "range": "roofs-and-patios",
    "category": "Roofs & patios",
    "tagline": "Open for winter sun, close for shade or rain",
    "hero": "/images/website/openingroof/vergolas3004.jpg",
    "intro": [
      "Control the elements with your new Vergola opening roof system from Greatway Patios. If you want to have a patio that you can enjoy in all seasons look no further than a Vergola. Vergolas are certainly an investment to enhance your lifestyle. Retain winter warming sun or create summer shade with the opening roof. At last you can control the elements with a Vergola.",
      "Away from home? And it starts to rain. No problems with Vergola! Fitted with a unique rain sensor, Vergola will automatically close when wet and reopen when dry. How is that for total control & peace of mind?",
      "Vergola design ideas are endless. Domestic to the large commercial work. Vergola has all the answers to your entertainment needs. Ask our experienced staff at Greatway Patios to assist with plans to suit your living requirements."
    ],
    "highlights": [],
    "sections": [],
    "images": [
      "/images/website/openingroof/leamonvergola.jpg",
      "/images/website/openingroof/vergolas002.jpg",
      "/images/website/openingroof/dullaway00.jpg",
      "/images/website/openingroof/freylingvergola-5.jpg",
      "/images/website/openingroof/vergolas3004.jpg",
      "/images/website/openingroof/img-0028.jpg",
      "/images/website/openingroof/image1.jpg",
      "/images/website/openingroof/img-0057.jpg",
      "/images/website/openingroof/vergolas004.jpg",
      "/images/website/openingroof/vergolas011.jpg",
      "/images/website/openingroof/vergolas3001.jpg",
      "/images/website/openingroof/vergolas3002.jpg",
      "/images/website/openingroof/vergolas3003.jpg",
      "/images/website/openingroof/image2.jpg",
      "/images/website/openingroof/freyling-completed-14.jpg",
      "/images/website/openingroof/image5.jpg"
    ]
  },
  {
    "slug": "carports",
    "legacySlug": "carports",
    "name": "Carports",
    "range": "roofs-and-patios",
    "category": "Roofs & patios",
    "tagline": "Free-standing or attached, flat or gable",
    "hero": "/images/website/carports/carport002.jpg",
    "intro": [
      "Greatway Patios can custom build your carport to further enhance your home. Our carports can be built free standing or attached to your house. Increase the value of your home with one of our custom designed carports and protect your vehicle at the same time. A win-win situation for you. We can build flat or gable style carports. Why not add some Colorbond steel lattice or slatting to give added protection and privacy. Greatway Patios has a large range of product samples and ideas in our showroom. Come and see us soon!"
    ],
    "highlights": [],
    "sections": [],
    "images": [
      "/images/website/carports/carport001.jpg",
      "/images/website/carports/carports003.jpg",
      "/images/website/carports/carport002.jpg",
      "/images/website/carports/spowart-carport00.jpg",
      "/images/website/carports/slatting006.jpg",
      "/images/website/carports/carport.jpg",
      "/images/website/carports/image1.jpg",
      "/images/website/carports/spowart-carport01.jpg",
      "/images/website/carports/greatwaycarport.jpg"
    ]
  },
  {
    "slug": "adjustable-louvres",
    "legacySlug": "adjustable-louvres",
    "name": "Adjustable Louvres",
    "range": "screens-and-shade",
    "category": "Screens & shade",
    "tagline": "Privacy and airflow, adjustable or fixed",
    "hero": "/images/website/louvresadjustable/adj-louvres.jpg",
    "intro": [
      "Greatway Patios' adjustable louvres are the ultimate innovation to create privacy while retaining air flow to your new patio. Greatway Patios have a range of adjustable and fixed louvres that will enhance your life style and add real value to your home. Most colours are available with options of Colorbond or powder coated aluminium finishes. Adjustable louvres are the perfect way to maximise your outdoor living options."
    ],
    "highlights": [],
    "sections": [],
    "images": [
      "/images/website/louvresadjustable/freylinglouvres.jpg",
      "/images/website/louvresadjustable/spc-louvres00.jpg",
      "/images/website/louvresadjustable/adj-louvres.jpg",
      "/images/website/louvresadjustable/louvres005.jpg",
      "/images/website/louvresadjustable/insulated-skillion-12.jpg",
      "/images/website/louvresadjustable/insulated-skillion-6.jpg",
      "/images/website/louvresadjustable/spc-louvres01.jpg",
      "/images/website/louvresadjustable/outsidedeck.jpg",
      "/images/website/louvresadjustable/gwp-simpson-lq-5.jpg",
      "/images/website/louvresadjustable/wallis-14.jpg",
      "/images/website/louvresadjustable/louvres007.jpg",
      "/images/website/louvresadjustable/louvre-bifold.jpg",
      "/images/website/louvresadjustable/grant009.jpg",
      "/images/website/louvresadjustable/louvres004.jpg",
      "/images/website/louvresadjustable/grant2004.jpg",
      "/images/website/louvresadjustable/miegel1.jpg",
      "/images/website/louvresadjustable/gwp-simpson-lq-6.jpg"
    ]
  },
  {
    "slug": "ziptrak-blinds",
    "legacySlug": "ziptrack-blinds",
    "name": "Ziptrak® Blinds",
    "range": "screens-and-shade",
    "category": "Screens & shade",
    "tagline": "Guided blinds — no gaps, no flapping",
    "hero": "/images/website/ziptrackblinds/gwp-zip-mesh-27.jpg",
    "intro": [
      "Our Ziptrak Blind System eliminates all the hard work of regular blinds. Pull down and push up! It's that easy to protect yourself from the elements with our guided blind system. No gaps and no flapping canvas.",
      "Available in clear or tinted PVC, acrylic awning fabrics or sunscreen mesh fabric, our Ziptrak Blind System gives you peace of mind all year round.",
      "Specially designed tracks on both sides, enables the fabric to glide smoothly and easily, stopping anywhere you want, and the blinds can be secured and locked in the down position to guard against high winds."
    ],
    "highlights": [
      "Available as Manual or Wireless Remote Operation",
      "Large range of quality fabrics to choose from",
      "No Zips, Ropes, Straps or Buckles"
    ],
    "sections": [],
    "images": [
      "/images/website/ziptrackblinds/fabric95-pelmets-3.jpg",
      "/images/website/ziptrackblinds/fabric-pelmets-dado-wall-2.jpg",
      "/images/website/ziptrackblinds/black-mesh-95.jpg",
      "/images/website/ziptrackblinds/fabric95.jpg",
      "/images/website/ziptrackblinds/gwp-zip-pvc-1.jpg",
      "/images/website/ziptrackblinds/fabric-95-pelmets-vergola.jpg",
      "/images/website/ziptrackblinds/fabric-95-pelmets.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-1.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-10.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-13.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-14.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-18.jpg",
      "/images/website/ziptrackblinds/black-mesh-95-3.jpg",
      "/images/website/ziptrackblinds/black-mesh-95-2.jpg",
      "/images/website/ziptrackblinds/gwp-zip-pvc-4.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-22.jpg",
      "/images/website/ziptrackblinds/black-mesh-95-4.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-21.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-23.jpg",
      "/images/website/ziptrackblinds/gwp-zip-pvc-2.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-25.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-27.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-28.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-29.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-3.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-38.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-4.jpg",
      "/images/website/ziptrackblinds/gwp-zip-mesh-6.jpg"
    ]
  },
  {
    "slug": "lattice-and-slatting",
    "legacySlug": "lattice-and-slatting",
    "name": "Lattice and Slatting",
    "range": "screens-and-shade",
    "category": "Screens & shade",
    "tagline": "Colorbond steel screens that never need painting",
    "hero": "/images/website/latticeandslatting/slatting-1.jpg",
    "intro": [
      "Greatway Patios and Superior Steel Screens work in conjunction to supply the best and most affordable lattice and slatting to suit your individual needs. We have lattice slatting fixed and movable louvres.",
      "All products are made from Colorbond steel with the availability of the complete Colorbond range of colours. You will never have to paint your lattice or screens again. Greatway Patios love how low maintenance this is. Well worth the free measure and quote!",
      "Ideal for privacy screens, gables, balustrades, patios, carports and fencing. Our staff will assist you in choosing the most suitable lattice or screens to go with your new patio or to solve that privacy problem."
    ],
    "highlights": [],
    "sections": [],
    "images": [
      "/images/website/latticeandslatting/slatscreen.jpg",
      "/images/website/latticeandslatting/spc-louvres02.jpg",
      "/images/website/latticeandslatting/slatting-1.jpg",
      "/images/website/latticeandslatting/slatting001.jpg",
      "/images/website/latticeandslatting/slats002.jpg",
      "/images/website/latticeandslatting/kemp2.jpg",
      "/images/website/latticeandslatting/bampton-slat00.jpg",
      "/images/website/latticeandslatting/miegel6.jpg",
      "/images/website/latticeandslatting/eastment1.jpg",
      "/images/website/latticeandslatting/slatting004.jpg",
      "/images/website/latticeandslatting/slats001.jpg",
      "/images/website/latticeandslatting/slatting008.jpg",
      "/images/website/carports/slatting006.jpg",
      "/images/website/latticeandslatting/bampton-slat01.jpg"
    ]
  },
  {
    "slug": "retractable-awnings",
    "legacySlug": "retractable-awnings",
    "name": "Retractable Awnings",
    "range": "screens-and-shade",
    "category": "Screens & shade",
    "tagline": "European-styled, adjustable pitch, no posts",
    "hero": "/images/website/retractableawnings/faa-gwp-2.jpg",
    "intro": [
      "Make the most of your outdoor entertainment area with our European-styled retractable awnings. Specifically made to maximise the use of your entertaining space, the area beneath the awnings are totally free from any obstructions.",
      "These retractable awnings are unique as they feature fully adjustable pitch to suit your needs at any time of the day, providing you with ultimate control of your environment. Hooding and additional powdercoating colours are also available.",
      "These are ideal for outdoor areas, decks, business premises, café and outdoor eateries."
    ],
    "highlights": [
      "No posts, no cords, no beams",
      "Automated or Manual models available"
    ],
    "sections": [],
    "images": [
      "/images/website/retractableawnings/faa-gwp-2.jpg",
      "/images/website/retractableawnings/faa-gwp-3.jpg",
      "/images/website/retractableawnings/awning002.jpg",
      "/images/website/retractableawnings/mcguire-fa00.jpg",
      "/images/website/retractableawnings/awnings001.jpg",
      "/images/website/retractableawnings/awnings002.jpg",
      "/images/website/retractableawnings/mcguire-fa01.jpg"
    ]
  },
  {
    "slug": "decks",
    "legacySlug": "decks",
    "name": "Decks",
    "range": "living-spaces",
    "category": "Living spaces",
    "tagline": "Merbau hardwood on galvanised steel frames",
    "hero": "/images/website/decks/archibald-13.jpg",
    "intro": [
      "At Greatway Patios, our staff will design a beautiful deck to suit your outdoor area. We will listen to your ideas and help create the perfect living area. You will enjoy entertaining friends and family on your new deck for years to come.",
      "We use the best quality Merbau hardwood timber decking. To ensure longevity all decking has galvanised steel framework and decking is screwed, not nailed. A final weather proof coating (no stain) is applied to the completed deck to complement your new area.",
      "At Greatway Patios we will take care of all the necessary council requirements and make sure all products complement each other in practicality and in function. Come in and see our showroom and see the quality of our decks first hand."
    ],
    "highlights": [],
    "sections": [],
    "images": [
      "/images/website/insulatedroof/img-0328.jpg",
      "/images/website/insulatedroof/img-0324.jpg",
      "/images/website/decks/img-0016.jpg",
      "/images/website/decks/img-0022.jpg",
      "/images/website/decks/archibald-1.jpg",
      "/images/website/decks/archibald-13.jpg",
      "/images/website/decks/kemp10.jpg",
      "/images/website/decks/img-0331.jpg",
      "/images/website/decks/image3.jpg",
      "/images/website/decks/image5.jpg",
      "/images/website/decks/kemp13.jpg",
      "/images/website/decks/image8.jpg",
      "/images/website/decks/image14.jpg",
      "/images/website/decks/image16.jpg"
    ]
  },
  {
    "slug": "outdoor-rooms",
    "legacySlug": "outdoor-rooms",
    "name": "Outdoor Rooms",
    "range": "living-spaces",
    "category": "Living spaces",
    "tagline": "Enclosures, garden rooms and screen rooms",
    "hero": "/images/website/outdoorrooms/img-0275.jpg",
    "intro": [
      "Do you need extra living space? Let Greatway Patios' trained staff design and create living areas from small offices to spacious room Enclosures. We will listen to your needs and design the ultimate extra living space.",
      "So expand your living area now! It will not only add value to your home but you will get years of enjoyment from a Greatway Patio room area that will enhance your lifestyle."
    ],
    "highlights": [
      "Extend your indoor living area with a room enclosure"
    ],
    "sections": [
      {
        "heading": "Enclosure with attached patios",
        "paras": [
          "Require more inside and outside living?",
          "Greatway Patios will design a beautiful room to flow onto your new outdoor patio.",
          "Take advantage of our free on site consultation to see how effortless it is to change your lifestyle. Entertain your friends this summer or winter in style."
        ]
      },
      {
        "heading": "Garden Room",
        "paras": [
          "Need somewhere to escape?",
          "Have Greatway Patios build a 'secret garden' room. Create that tranquil area for you to sit back and relax.",
          "Picture yourself with the paper and a cup of coffee and enjoy the outdoors from indoors. Let our trained staff show you just how easy it is to design an area for you now."
        ]
      },
      {
        "heading": "Screen Room",
        "paras": [
          "A beautiful screen room will give you and your family years of insect free living.",
          "Let Greatway Patios designers show you how simple it is to enjoy this summer in Style."
        ]
      }
    ],
    "images": [
      "/images/website/outdoorrooms/img-0213.jpg",
      "/images/website/insulatedroof/gable-patiolq.jpg",
      "/images/website/outdoorrooms/img-0214.jpg",
      "/images/website/outdoorrooms/sanderson-4.jpg",
      "/images/website/outdoorrooms/sanderson-8.jpg",
      "/images/website/outdoorrooms/img-0276.jpg",
      "/images/website/outdoorrooms/img-0275.jpg",
      "/images/website/outdoorrooms/image17.jpg",
      "/images/website/insulatedroof/gable-patiol-5lq.jpg"
    ]
  },
  {
    "slug": "glass-balustrade",
    "legacySlug": "glass-balustrade",
    "name": "Glass Balustrade",
    "range": "living-spaces",
    "category": "Living spaces",
    "tagline": "Frameless glass that won't spoil your views",
    "hero": "/images/website/glassbalustrade/balustrading007.jpg",
    "intro": [
      "Designed to suit a number of applications, our frameless glass balustrades are a safe option that won't spoil your views.",
      "Our Frameless balustrade system is broken into 2 specific designs.",
      "Euro Design: This is where the handrail is offset from the glass. Two handrails are available 50mm X 25mm rectangle and a 38mm round. All appropriate brackets, caps, corners, joiners etc are available in both high polish and satin finish including adjustable for stairs or raked sections.",
      "Summit Design: This is where the handrail sits on top of the glass. Three handrails are available 54mm X 30mm rectangle handrail and a 38mm slotted round and a 15mm X 15mm internal U channel rail. All appropriate brackets, caps, corners, joiners etc are available in both high polish and satin finish including adjustable for stairs or raked sections."
    ],
    "highlights": [],
    "sections": [],
    "images": [
      "/images/website/glassbalustrade/balustrading011.jpg",
      "/images/website/glassbalustrade/balustrading007.jpg",
      "/images/website/glassbalustrade/balustrading003.jpg",
      "/images/website/glassbalustrade/balustrading002.jpg",
      "/images/website/glassbalustrade/balustrading2002.jpg"
    ]
  }
];

const BY_SLUG = new Map(PRODUCTS.map((p) => [p.slug, p]));

/** Look up a product by its current slug. */
export function productBySlug(slug: string): Product | undefined {
  return BY_SLUG.get(slug);
}

/** The products in one range, in display order. */
export function productsInRange(range: RangeId): Product[] {
  return PRODUCTS.filter((p) => p.range === range);
}
